import React, { useState } from 'react'

import { Helmet } from 'react-helmet'
import { useHistory } from 'react-router-dom'

import './login3.css'

const Login3 = () => {
  const history = useHistory()
  const [userId, setUserId] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const handleSignIn = () => {
    const normalizedUserId = userId.trim()
    const normalizedPassword = password.trim()

    if (normalizedUserId === 'admin' && normalizedPassword === 'admin') {
      setErrorMessage('')
      history.push('/dashboard')
      return
    }

    setErrorMessage('Invalid credentials. Use admin for both fields.')
  }

  const handleInputChange = (
    setter: React.Dispatch<React.SetStateAction<string>>,
    value: string
  ) => {
    setter(value)
    if (errorMessage) {
      setErrorMessage('')
    }
  }

  return (
    <div className="login3-container1">
      <Helmet>
        <title>exported project</title>
        <meta property="og:title" content="exported project" />
        <link
          rel="canonical"
          href="https://namami-ganga-design-file-pvya6a.teleporthq.app/"
        />
        <meta
          property="og:url"
          content="https://namami-ganga-design-file-pvya6a.teleporthq.app/"
        />
      </Helmet>
      <div className="login3-thq-login3-elm">
        <div className="login3-thq-overlaysignin-elm">
          <img
            src="/namamigangelogohindi11759-tdli-200h.png"
            alt="NamamiGangeLogoHindi11759"
            className="login3-thq-namami-gange-logo-hindi1-elm1"
          />
          <div className="login3-thq-email-elm1">
            <div className="login3-thq-frame243-elm1">
              <span className="login3-thq-text-elm10">User ID</span>
            </div>
            <input
              type="text"
              className="login3-thq-textfield-elm1"
              value={userId}
              placeholder="Enter your User ID"
              onChange={(event) =>
                handleInputChange(setUserId, event.target.value)
              }
              autoComplete="off"
            />
          </div>
          <div className="login3-thq-email-elm2">
            <div className="login3-thq-frame243-elm2">
              <span className="login3-thq-text-elm11">Password</span>
            </div>
            <input
              type="password"
              className="login3-thq-textfield-elm2"
              value={password}
              placeholder="Enter your Password"
              onChange={(event) =>
                handleInputChange(setPassword, event.target.value)
              }
              autoComplete="off"
            />
          </div>
          <span className="login3-thq-text-elm12">Secure Entry</span>
          <span className="login3-thq-text-elm13">
            Sign in to access the command centre
          </span>
          <span className="login3-thq-text-elm14">
            Your data is protected with advanced encryption
          </span>
          <img
            src="/mail1767-je2.svg"
            alt="Mail1767"
            className="login3-thq-mail-elm"
          />
          <span className="login3-thq-text-elm17">Remember me</span>
          <span className="login3-thq-text-elm18">Forgot Password?</span>
          <img
            src="/rectangle346257711770-2b4p-200h.png"
            alt="Rectangle346257711770"
            className="login3-thq-rectangle34625771-elm"
          />
          <img
            src="/icons1771-7pgg.svg"
            alt="Icons1771"
            className="login3-thq-icons-elm"
          />
          <div className="login3-thq-frame374-elm">
            <button
              type="button"
              className="login3-thq-button-elm"
              onClick={handleSignIn}
            >
              <div className="login3-thq-frame276-elm">
                <span className="login3-thq-text-elm19">Sign in</span>
              </div>
            </button>
          </div>
          {errorMessage && (
            <span className="login3-thq-login-error-elm">{errorMessage}</span>
          )}
          <img
            src="/lockclosed1774-cg19b.svg"
            alt="LockClosed1774"
            className="login3-thq-lock-closed-elm"
          />
        </div>
        <span className="login3-thq-text-elm20">National Mission</span>
        <span className="login3-thq-text-elm21">for Clean Ganga</span>
        <img
          src="/namamigangelogohindi11777-whs4-200h.png"
          alt="NamamiGangeLogoHindi11777"
          className="login3-thq-namami-gange-logo-hindi1-elm2"
        />
        <img
          src="/rectangle346257721778-1tc-200h.png"
          alt="Rectangle346257721778"
          className="login3-thq-rectangle34625772-elm"
        />
        <span className="login3-thq-text-elm22">Multi Layer Security</span>
        <span className="login3-thq-text-elm23">Audit &amp; Compliance</span>
        <span className="login3-thq-text-elm24">Advanced Protection</span>
        <span className="login3-thq-text-elm25">24/7 Support</span>
        <span className="login3-thq-text-elm26">
          Role-based access with secure authentication
        </span>
        <span className="login3-thq-text-elm27">
          Every login is logged for transparency &amp; compliance
        </span>
        <span className="login3-thq-text-elm28">
          OTP, Biometric &amp; encryption for enhanced security
        </span>
        <span className="login3-thq-text-elm29">
          We are here to help you anytime, anywhere
        </span>
        <img
          src="/shieldcheckmark1787-33be.svg"
          alt="ShieldCheckmark1787"
          className="login3-thq-shield-checkmark-elm"
        />
        <img
          src="/personsupport1788-b9yd.svg"
          alt="PersonSupport1788"
          className="login3-thq-person-support-elm"
        />
        <img
          src="/fingerprint1789-kawd.svg"
          alt="Fingerprint1789"
          className="login3-thq-fingerprint-elm"
        />
        <img
          src="/personaccounts1790-mlwm.svg"
          alt="PersonAccounts1790"
          className="login3-thq-person-accounts-elm"
        />
        <img
          src="/rectangle346257731791-qhmc-200h.png"
          alt="Rectangle346257731791"
          className="login3-thq-rectangle34625773-elm"
        />
        <span className="login3-thq-text-elm30">Version 1.0</span>
        <span className="login3-thq-text-elm31">
          Developed by Karnics Technologies
        </span>
        <img
          src="/line4791794-1egr.svg"
          alt="Line4791794"
          className="login3-thq-line479-elm"
        />
        <img
          src="/line4801795-7joh.svg"
          alt="Line4801795"
          className="login3-thq-line480-elm"
        />
        <img
          src="/rectangle346257741796-7hg-200h.png"
          alt="Rectangle346257741796"
          className="login3-thq-rectangle34625774-elm"
        />
        <span className="login3-thq-text-elm32">
          SECURE &amp; COMPLIANT
          <span
            dangerouslySetInnerHTML={{
              __html: ' ',
            }}
          />
        </span>
        <span className="login3-thq-text-elm33">NGT Compliant System</span>
        <img
          src="/shield1799-zc8b.svg"
          alt="Shield1799"
          className="login3-thq-shield-elm"
        />
        <img
          src="/eye1800-jv5.svg"
          alt="Eye1800"
          className="login3-thq-eye-elm"
        />
      </div>
    </div>
  )
}

export default Login3

